import React from 'react';
import { LTButton, LTFlash, LTText, LTTooltip } from '@lambdatestincprivate/lt-components';
import WarningIcon from '../../assets/WarningIcon';
import TestMuAIIcon from '../../assets/TestMuAIIcon';

const triggerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  padding: '0',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '20px',
  color: '#CF222E',
  maxWidth: '250px',
};

const textStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const truncateText = (text, maxLen = 30) => {
  if (!text || text.length <= maxLen) return text;
  return `${text.slice(0, maxLen)}...`;
};

const flashExtraStyles = {
  borderRadius: '6px',
  border: '1px solid',
  borderColor: 'danger.muted',
  width: '100%',
  height: 'auto',
  padding: '8px',
  alignItems: 'center',
  gap: '12px',
  svg: {
    margin: '0px',
  },
};

const flashContentStyles = {
  alignItems: 'center',
  padding: '0',
};

const RCAFlashBanner = ({ text, buttonLabel, isLoading, onAction }) => (
  <LTFlash
    variant="danger"
    iconComponent={
      <span
        style={{
          padding: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <WarningIcon />
      </span>
    }
    text={
      <LTText
        fontSize={LTText.FontSize.FONT_14}
        fontWeight="600"
        color="text.default"
        margin="0"
      >
        {text}
      </LTText>
    }
    secondaryAction={
      <LTButton
        leadingIcon={<TestMuAIIcon />}
        variant={LTButton.Variant.AI}
        size={LTButton.Size.MEDIUM}
        disabled={isLoading}
        onClick={(e) => {
          e?.stopPropagation?.();
          onAction?.();
        }}
        aria-label={buttonLabel}
        style={{ fontWeight: 600 }}
      >
        {buttonLabel}
      </LTButton>
    }
    extraStyles={flashExtraStyles}
    contentStyles={flashContentStyles}
  />
);

const RCARowTrigger = ({ rcaCategory, isLoading, onGenerateRCA, onViewRCA, showGenerate, bannerMode }) => {
  if (rcaCategory) {
    if (bannerMode) {
      return (
        <RCAFlashBanner
          text={rcaCategory}
          buttonLabel="View RCA"
          isLoading={isLoading}
          onAction={onViewRCA}
        />
      );
    }

    const handleKeyDown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onViewRCA?.();
      }
    };

    return (
      <LTTooltip text={rcaCategory}>
        <div
          role="button"
          tabIndex={0}
          aria-label={`View RCA: ${rcaCategory}`}
          style={triggerStyles}
          onClick={(e) => {
            e?.stopPropagation?.();
            onViewRCA?.();
          }}
          onKeyDown={handleKeyDown}
        >
          <WarningIcon />
          <span style={textStyles}>{truncateText(rcaCategory)}</span>
        </div>
      </LTTooltip>
    );
  }

  if (!showGenerate) return null;

  if (bannerMode) {
    return (
      <RCAFlashBanner
        text="Generate RCA to view the root cause for this failure"
        buttonLabel="Generate RCA"
        isLoading={isLoading}
        onAction={onGenerateRCA}
      />
    );
  }

  return (
    <LTButton
      variant={LTButton.Variant.AI}
      size={LTButton.Size.MEDIUM}
      style={{ fontWeight: 600 }}
      ariaLabel="Generate RCA"
      leadingIcon={<TestMuAIIcon />}
      disabled={isLoading}
      onClick={(e) => {
        e?.stopPropagation?.();
        onGenerateRCA?.();
      }}
    >
      Generate RCA
    </LTButton>
  );
};

export default RCARowTrigger;
